import {getTabPane, initColumnParams} from '@/util/componentUtil';
import listPageBaseMixin from '../x-list-page/list-page-base-mixin';
import pageMixin from '../../mixin/page-mixin';
import tableOperateConfigMixin from '../../mixin/table-operate-config-mixin';
import tableOperateMixin from '../../mixin/table-operate-mixin';
import tableSettingConfigMixin from '../../mixin/table-setting-config-mixin';
import {Pagination, Tabs, TabPane} from 'element-ui';
import {Toolbar} from 'vxe-table';
import downloadDialogMixin from "@/component/x-download-dialog/download-dialog-mixin";

export default {
  mixins: [downloadDialogMixin, pageMixin, tableSettingConfigMixin, tableOperateConfigMixin, tableOperateMixin, listPageBaseMixin],
  components: {
    [Pagination.name]: Pagination,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Toolbar.name]: Toolbar,
  },
  props: {
    tabConfig: {
      type: Object,
      default() {
        return {
          field: '',
          activeName: '',
          type: 'card',
          list: [
            {
              columns: [],
              name: '',
              label: ''
            }
          ]
        };
      }
    }
  },
  methods: {
    getCheckboxRecords() {
      return this.getCurrentTableInstance().getCheckboxRecords();
    },
    getCurrentTableInstance() {
      const tabPaneInstance = this.getCurrentTabPaneInstance();
      if (!tabPaneInstance) {
        return null;
      }
      const child = tabPaneInstance.$children[0];
      // 当只有一个table是，$refs.xTable不是一个数组
      if (!Array.isArray(this.$refs.xTable)) {
        if (!this.$refs.xTable) {
          return null;
        }
        // 判断第一个children和xTable是不是同一个对象，如果tabPane使用了插槽，就不会相同
        if (child === this.$refs.xTable) {
          return this.$refs.xTable;
        } else {
          return null;
        }
      }
      // 是数组，就需要遍历
      for (let i = 0; i < this.$refs.xTable.length; i++) {
        if (child === this.$refs.xTable[i]) {
          return child;
        }
      }
      return null;
    },
    getCurrentTabPane() {
      return getTabPane({name: this.tabConfig.activeName, tabConfig: this.tabConfig});
    },
    getCurrentTabPaneInstance() {
      for (let i = 0; i < this.tabConfig.list.length; i++) {
        if (this.tabConfig.list[i].name === this.tabConfig.activeName) {
          return this.$refs.tabPane[i];
        }
      }
      return null;
    },
    getCurrentGridInstance() {
      const xTable = this.getCurrentTableInstance();
      if (!xTable) {
        return null;
      }
      return xTable.getGridInstance();
    },
    handleResize () {
      const grid = this.getCurrentGridInstance();
      if (grid) {
        grid.recalculate(true);
      }
    },
    hasDataAttribute() {
      const tabPane = this.getCurrentTabPane();
      return Object.prototype.hasOwnProperty.call(tabPane, 'data');
    },
    setSummary(summary) {
      this.getCurrentTabPane().summary = summary;
    },
    loadData(data) {
      this.getCurrentTableInstance().loadData(data);
    },
    getXTable() {
      return this.$refs.xTable;
    },
    /**
     * 初始化表格拖拽
     * @return {Promise<unknown>}
     */
    initTableSetting() {
      let resolveFn;
      const promise = new Promise((resolve) => {
        resolveFn = resolve;
      });
      setTimeout(() => {
        const promiseArr = [];
        for (let i = 0; i < this.$refs.xTable.length; i++) {
          promiseArr.push(this.$refs.xTable[i].initTableSetting());
        }
        Promise.all(promiseArr).then(() => {
          resolveFn();
        });
      });
      return promise;
    },
    initCurrentTableSetting() {
      const tableInstance = this.getCurrentTableInstance();
      if (!tableInstance) {
        return;
      }
      let resolveFn;
      const promise = new Promise((resolve) => {
        resolveFn = resolve;
      });
      setTimeout(() => {
        tableInstance.initTableSetting();
      });
      return promise;
    }
  },
  created() {
    if (!this.tabConfig) {
      return;
    }
    const list = this.tabConfig.list;
    if (!Array.isArray(list)) {
      return;
    }
    for (const tabPane of list) {
      initColumnParams({columns: tabPane.columns});
    }
  },
  mounted() {
    for (let i = 0; i < this.$refs.xTable.length; i++) {
      this.$refs.xTable[i].getGridInstance().connect(this.$refs.vxeToolbar[i]);
    }
  },
  watch: {
    'tabConfig.list': {
      handler(list) {
        if (!this.autoInitTableSetting) {
          return;
        }
        // 由于vue2无法监听数组内容的变更，需要自行缓存数据
        if (!this.oldList) {
          // 第一次触发，oldList是undefined
          this.oldList = JSON.parse(JSON.stringify(list));
          this.initTableSetting();
          return;
        }
        // 对比每个tab的新和旧的columns，如果columns不一样，就重新initTableSetting
        for (const tabPane of list) {
          for (const oldTabPane of this.oldList) {
            if (oldTabPane.name !== tabPane.name) {
              continue;
            }
            const oldColumns = oldTabPane.columns;
            const columns = tabPane.columns;
            if (!Array.isArray(columns)) {
              break;
            }
            if (!Array.isArray(oldColumns) || oldColumns.length !== columns.length) {
              this.initCurrentTableSetting();
              break;
            }
            // 判断columns和oldColumns的所有field是否一致
            const map = {};
            for (const column of columns) {
              map[column.field] = column;
            }
            for (const column of oldColumns) {
              if (!map[column.field]) {
                this.initCurrentTableSetting();
                break;
              }
            }
            break;
          }
        }
        this.oldList = JSON.parse(JSON.stringify(list));
      },
      immediate: true,
      deep: true
    }
  }
};
